<div class="state-list-container">
  <nz-list [nzDataSource]="states" [nzItemLayout]="'horizontal'">
    @for (item of states; track item.id) {
      <nz-list-item [nzActions]="[editAction, deleteAction]">
        <nz-list-item-meta
          [nzTitle]="item.name"
          [nzDescription]="descriptionTemplate"
        >
          <ng-template #descriptionTemplate>
            <p>Providers: {{ item.providers.join(', ') }}</p>
            <nz-tag [nzColor]="item.color">{{ item.color }}</nz-tag>
          </ng-template>
        </nz-list-item-meta>
        <ng-template #editAction>
          <a *ngIf="hasPermission('manage_states')" (click)="editState(item)">Edit</a>
        </ng-template>
        <ng-template #deleteAction>
          <a nz-popconfirm nzPopconfirmTitle="Are you sure you want to delete this state?" (nzOnConfirm)="deleteState(item.id)">Delete</a>
        </ng-template>
      </nz-list-item>
    }
  </nz-list>

  <nz-back-top></nz-back-top>

  <button *ngIf="hasPermission('manage_states')" nz-button nzType="primary" nzShape="circle" class="fab-button" (click)="addState()">
    <i nz-icon nzType="plus"></i>
  </button>
</div>
